import { ChakraV3, Dot } from '@piccolohealth/ui';
import { P } from '@piccolohealth/util';
import type { Editor } from '@tiptap/react';
import React from 'react';
import { FaCheck } from 'react-icons/fa';
import { COLORS } from '../utils';

interface Props {
  editor: Editor;
}

export const TableBackgroundSelect = (props: Props) => {
  const { editor } = props;

  const items = [{ hex: 'transparent', title: 'No fill' }, ...COLORS];

  const action = (color: string) => {
    editor.chain().setCellAttribute('backgroundColor', color).run();
  };

  const activeItem =
    items.find((item) => editor.isActive('tableCell', { backgroundColor: item.hex })) ?? items[0];
  const activeHex = activeItem?.hex;

  if (P.isUndefined(activeHex)) {
    return null;
  }

  const buttonBorder =
    activeHex === 'transparent' ? { borderWidth: '2px', borderColor: 'black' } : {};

  return (
    <ChakraV3.Menu.Root positioning={{ placement: 'bottom' }} lazyMount>
      <ChakraV3.Tooltip content='Cell background color'>
        <ChakraV3.Box>
          <ChakraV3.Menu.Trigger asChild>
            <ChakraV3.IconButton
              variant='ghost'
              size='sm'
              rounded='md'
              bg='white'
              fontSize='18px'
              fontWeight='light'
            >
              <ChakraV3.Square bg={activeHex} size={3} rounded='xs' {...buttonBorder} />
            </ChakraV3.IconButton>
          </ChakraV3.Menu.Trigger>
        </ChakraV3.Box>
      </ChakraV3.Tooltip>

      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          {items.map((item) => {
            return (
              <ChakraV3.MenuItem
                key={item.title}
                onClick={() => action(item.hex)}
                fontSize='xs'
                py={1}
                px={1}
                value={item.title}
              >
                <ChakraV3.HStack w='full'>
                  <Dot bg={item.hex} size={3} />
                  {item.title}
                  <ChakraV3.Spacer />
                  {activeItem === item && <FaCheck fontSize='10px' />}
                </ChakraV3.HStack>
              </ChakraV3.MenuItem>
            );
          })}
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
